// Generated by scripts/build-ui-icons.mjs.
export { Wallet as default } from "../ui/glyphs-8";
